import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, withContext } from 'recompose';

import { getExtension } from '../../extensions';
import withExtensions from '../../extensions/withExtensions';

export default compose(
  withExtensions,
  withRouter,
  connect(
    (state, props) => ({
      extension: getExtension(state, props.params.brandRoute),
    })
  ),
  lifecycle({
    componentDidMount() {
      this.props.fetchExtension(this.props.params.brandRoute);
    },
  }),
  withContext(
    { extension: PropTypes.object },
    props => ({ extension: props.extension }),
  ),
);



// WEBPACK FOOTER //
// ./src/app/notifications/hoc/withExtensionContextProvider.js